import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getFormById, saveFormResponse, updateFormResponse, incrementViews } from "../../api/form";
import styles from './Formbots.module.css';
import send from '../../images/send.svg';
import chaticon from '../../images/chaticon.svg';

export default function Formbots() {
  const formid = useParams();
  const [form, setFormdata] = useState(null);
  const [responses, setResponses] = useState({});
  const [formbotid, setFormbotid] = useState(null); // State to store formbot ID
  const [visibleIndex, setVisibleIndex] = useState(0); // State to track the last visible field index
  const [disabledFields, setDisabledFields] = useState({}); // State to track disabled/read-only fields

  useEffect(() => {
    const fetchForm = async () => {
      try {
        const formdata = await getFormById(formid);
        setFormdata(formdata);

        await incrementViews(formid);
        // Find the index of the first field from input20 group
        let firstInputIndex = formdata.fields.findIndex(field => !['Image', 'Video', 'Gif', 'Text'].includes(field.type));
        
        // Set the visibleIndex to the index of the first input field
        if (firstInputIndex === -1) {
          // No input fields found, so show all fields
          setVisibleIndex(formdata.fields.length - 1);
        } else {
          setVisibleIndex(firstInputIndex);
        }

      } catch (error) {
        console.error('Error fetching form:', error);
      }
    };

    fetchForm();
  }, [formid]);

  const handleChange = (fieldId, value) => {
   // console.log(fieldId + " is " + value);
    setResponses(prevResponses => {
      const updatedResponses = {
        ...prevResponses,
        [fieldId]: value
      };
    //  console.log("Updated responses:", updatedResponses); // Log updated state
      return updatedResponses;
    });
  };

  const handleButtonClick = async (fieldId, type) => {
    try {
      const responseData = [{
        id: fieldId,
        type: type,
        value: responses[fieldId] || 'None'
      }];

      if (formbotid) {
        // Update existing response
        await updateFormResponse(formbotid, responseData);
      } else {
        const newResponseData = {
          formId: formid.id,
          responses: responseData
        };
        // Save new response and set formbotid
        const savedResponse = await saveFormResponse(newResponseData);
        setFormbotid(savedResponse._id); // Assuming the response includes the saved ID
      }

      // Disable the input and button after clicking
      setDisabledFields(prevDisabledFields => ({
        ...prevDisabledFields,
        [fieldId]: true
      }));

      // Reveal the next set of fields up to and including the next right-side input field
      let nextIndex = visibleIndex + 1;
      while (nextIndex < form.fields.length) {
        if (!['Image', 'Video', 'Gif', 'Text'].includes(form.fields[nextIndex].type)) {
          break; // Stop at the next right-side input field
        }
        nextIndex++;
      }
      setVisibleIndex(nextIndex);

     // alert('Response saved successfully!');
    } catch (error) {
      console.error('Error saving response:', error);
    }
  };

  if (!form) {
    return <div style={{ color: 'black' }}>Loading...</div>;
  }

  const renderField = (field) => {
    const isDisabled = disabledFields[field.id];

    switch (field.type) {
      case 'Image':
        return <img className={styles.Image} src={field.value} alt='' />;
      case 'Video':
        return <video className={styles.Image} src={field.value} controls />;
      case 'Gif':
        return <img className={styles.Image} src={field.value} alt='' />;
      case 'Text':
        return <textview className={styles.Text}>{field.value}</textview>;
      case 'TextInput':
        return (
          <input
            type="text"
            placeholder="Enter your text"
            className= {isDisabled ? styles.disabledButton : styles.normalButton}
            onChange={e => handleChange(field.id, e.target.value)}
            readOnly={isDisabled}
          />
        );
      case 'Number':
        return (
          <input
            type="number"
            placeholder="Enter a number"
            className= {isDisabled ? styles.disabledButton : styles.normalButton}
            onChange={e => handleChange(field.id, e.target.value)}
            readOnly={isDisabled}
          />
        );
      case 'Email':
        return (
          <input
            type="email"
            placeholder="Enter your email"
            className= {isDisabled ? styles.disabledButton : styles.normalButton}
            onChange={e => handleChange(field.id, e.target.value)}
            readOnly={isDisabled}
          />
        );
      case 'Phone':
        return (
          <input
            type="tel"
            placeholder="Enter your phone"
            className= {isDisabled ? styles.disabledButton : styles.normalButton}
            onChange={e => handleChange(field.id, e.target.value)}
            readOnly={isDisabled}
          />
        );
      case 'Date':
        return (
          <input
            type="date"
            placeholder="Select a date"
            className= {isDisabled ? styles.disabledButton : styles.normalButton}
            onChange={e => handleChange(field.id, e.target.value)}
            readOnly={isDisabled}
          />
        );
      case 'Rating':
        return (
          <input
            type="number"
            max="5"
            min="1"
            placeholder="Rating"
            className= {isDisabled ? styles.disabledButton : styles.normalButton}
            onChange={e => handleChange(field.id, e.target.value)}
            readOnly={isDisabled}
          />
        );
      case 'Button':
        return (
          <button
            className= {isDisabled ? styles.disabledbuttons : styles.buttons}
            type="button"
            onClick={  async() => { // Ensure handleChange completes first
              await handleChange(field.id, field.value);
              handleButtonClick(field.id, field.type);
            }}
            disabled={isDisabled}
          >
            {field.value || 'Submit'}
          </button>
        );
      default:
        return null;
    }
  };
  const d = form.color1;
//  console.log(form);
  return (
    
    <div style={{ backgroundColor: d === 0 ? '' : d === 1 ? '#171923' : '#508C9B' , width: '100vw',height: '100vh' }}>
    <div className={styles.Formbots} >
      <form>
        <div className={styles.formbotContainer} >
          {form.fields.map((field, index) => {
            if (index > visibleIndex) return null; // Only render fields up to the visibleIndex

            const isLeftSide = ['Image', 'Video', 'Gif', 'Text'].includes(field.type);
            //const isRightSide = !isLeftSide;

            return (
              <div key={index} className={styles.formbotContainer2}>
                {isLeftSide ? (
                  <div className={styles.bubbles11}>
                    <div>
                      <img src={chaticon} alt="" />
                    </div>
                    <div className={styles.bubbles20}>
                      {renderField(field)}
                    </div>
                  </div>
                ) : (
                  <div className={styles.inputs11}>
                   
                    
                    <div className={styles.inputs20}>
                      {renderField(field)}
                      
                      {!['Button', 'Image', 'Video', 'Gif', 'Text'].includes(field.type) && 
                        <button
                          type="button"
                          className= {disabledFields[field.id] ? styles.disabledButton2 : styles.normalButton2}
                          onClick={() => handleButtonClick(field.id, field.type)}
                          disabled={disabledFields[field.id]}
                        >
                          <img src={send} alt='' />
                        </button>}
                    </div>
                    
          
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </form>
    </div>
    </div>
  );
}
